<template lang="pug">
  .discus-wrapper.xs-12.xs-f-small.md-f-medium.lg-f-small.max-at-tweak(v-pre)
    .padded-wrap.xs-12
      #disqus_thread
</template>

<script>

export default {
  name: "BlogDisqus",
  props: {
    environment: {
      type: String,
      default: 'dev'
    },
    contentUrl: {
      type: String,
      default: ''
    },
    contentId: {
      type: String,
      default: ''
    }
  },

  mounted() {
    this.loadDisqus();
  },

  methods: {
    loadDisqus() {
     const ctx = this;

     window.disqus_config = function () {
        this.page.url = ctx.contentUrl;
        this.page.identifier = ctx.contentId;
        this.callbacks.onNewComment = [function () {
          window.dataLayer.push({'event': 'MRCustom', 'category': 'Comments', 'action': 'New Comment', 'label': 'blog comment'});
        }];
      };

      const d = document, s = d.createElement('script');
      s.src = this.getEmbeddedUrl();
      s.setAttribute('data-timestamp', +new Date());
      (d.head || d.body).appendChild(s);
    },

    getEmbeddedUrl() {
      let envPrefix = '';

      switch (this.environment) {
        case 'stage':
          envPrefix = 'staging-';
          break;
        case 'dev':
          envPrefix = 'cmspreview-';
          break;
        default:
          envPrefix = '';
      }

      return `//${envPrefix}madison-reed.disqus.com/embed.js`;
    }
  }
};
</script>

